// // import React from 'react';

// // import cx from 'classnames';
// // import PropTypes from 'prop-types';
// // import CSSModule from 'react-css-modules';
// // import { FormattedMessage } from 'react-intl';

// // import messages from './messages';
// // import styles from './Spinner.module.scss';

// // const Spinner = ({ show, containerClassName, color, size, justify }) => {
// //   if (!show) {
// //     return null;
// //   }

// //   return (
// //     <div
// //       className={cx(
// //         containerClassName,
// //         'd-flex',
// //         'align-items-center',
// //         `justify-content-${justify}`,
// //       )}
// //     >
// //       <div
// //         styleName={cx(`spinner-border-${size}`)}
// //         className={cx('spinner-border', `text-${color}`)}
// //         role="status"
// //       >
// //         <span className="sr-only">
// //           <FormattedMessage {...messages.loadingText} />
// //         </span>
// //       </div>
// //     </div>
// //   );
// // };

// // Spinner.defaultProps = {
// //   color: 'secondary',
// //   size: 'md',
// //   justify: 'center',
// // };

// // Spinner.propTypes = {
// //   show: PropTypes.bool,
// //   containerClassName: PropTypes.string,
// //   /**
// //    * Component color variations.
// //    * @type {('primary'|'secondary'|'success'|'danger'|'warning'|'info'|'light'|'dark')}
// //    */
// //   color: PropTypes.string,
// //   /**
// //    * Component size variations.
// //    * @type {('sm'|'md'|'lg')}
// //    */
// //   size: PropTypes.string,
// //   /**
// //    * Component position variations.
// //    * @type {('left'|'center'|'end')}
// //    */
// //   justify: PropTypes.string,
// // };

// // export default CSSModule(Spinner, styles, { allowMultiple: true });
// import React from 'react';

// import cx from 'classnames';
// import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';

// import messages from './messages';

// /**
//  * DESIGN UPDATE: markup/styling only was ported off react-css-modules /
//  * Bootstrap spinner classes onto a plain Tailwind spinning ring that uses
//  * the same red gradient accent as the rest of the new design. Props,
//  * defaults, and behavior (show/hide, size, color, justify) are unchanged —
//  * this remains a drop-in replacement everywhere <Spinner /> is used.
//  */
// const SIZE_CLASSES = {
//   sm: 'w-4 h-4 border-2',
//   md: 'w-6 h-6 border-2',
//   lg: 'w-9 h-9 border-[3px]',
// };

// const JUSTIFY_CLASSES = {
//   start: 'justify-start',
//   left: 'justify-start',
//   center: 'justify-center',
//   end: 'justify-end',
// };

// // Kept for API compatibility with callers passing Bootstrap-style color
// // props (e.g. "danger", "primary"); maps to the new gradient accent for the
// // brand colors and falls back to a neutral gray otherwise.
// const COLOR_CLASSES = {
//   primary: 'border-t-red-600',
//   danger: 'border-t-red-600',
//   secondary: 'border-t-neutral-400',
//   success: 'border-t-emerald-500',
//   warning: 'border-t-amber-500',
//   info: 'border-t-sky-500',
//   light: 'border-t-neutral-200',
//   dark: 'border-t-neutral-700',
// };

// const Spinner = ({ show, containerClassName, color, size, justify }) => {
//   if (!show) {
//     return null;
//   }

//   return (
//     <div className={cx(containerClassName, 'flex items-center', JUSTIFY_CLASSES[justify] || JUSTIFY_CLASSES.center)}>
//       <div
//         role="status"
//         className={cx(
//           'rounded-full border-neutral-200 animate-spin',
//           SIZE_CLASSES[size] || SIZE_CLASSES.md,
//           COLOR_CLASSES[color] || COLOR_CLASSES.secondary,
//         )}
//       >
//         <span className="sr-only">
//           <FormattedMessage {...messages.loadingText} />
//         </span>
//       </div>
//     </div>
//   );
// };

// Spinner.defaultProps = {
//   color: 'secondary',
//   size: 'md',
//   justify: 'center',
// };

// Spinner.propTypes = {
//   show: PropTypes.bool,
//   containerClassName: PropTypes.string,
//   /**
//    * Component color variations.
//    * @type {('primary'|'secondary'|'success'|'danger'|'warning'|'info'|'light'|'dark')}
//    */
//   color: PropTypes.string,
//   /**
//    * Component size variations.
//    * @type {('sm'|'md'|'lg')}
//    */
//   size: PropTypes.string,
//   /**
//    * Component position variations.
//    * @type {('left'|'center'|'end')}
//    */
//   justify: PropTypes.string,
// };

// export default Spinner;

import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';
import CSSModule from 'react-css-modules';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import styles from './Spinner.module.scss';

/**
 * DESIGN UPDATE: markup/styling only was ported off Bootstrap's
 * spinner-border classes onto a small custom CSS ring that uses the same
 * red-gradient accent as the rest of the new design (see
 * Spinner.module.scss). Still built on react-css-modules/styleName like the
 * rest of this codebase. Props, defaults, and behavior (show/hide, size,
 * color, justify) are unchanged — this remains a drop-in replacement
 * everywhere <Spinner /> is used.
 */
const Spinner = ({ show, containerClassName, color, size, justify }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={containerClassName} styleName={cx('spinner-wrap', `justify-${justify}`)}>
      <div role="status" styleName={cx('ring', `ring-${size}`, `ring-${color}`)}>
        <span styleName="sr-only">
          <FormattedMessage {...messages.loadingText} />
        </span>
      </div>
    </div>
  );
};

Spinner.defaultProps = {
  color: 'secondary',
  size: 'md',
  justify: 'center',
};

Spinner.propTypes = {
  show: PropTypes.bool,
  containerClassName: PropTypes.string,
  /**
   * Component color variations.
   * @type {('primary'|'secondary'|'success'|'danger'|'warning'|'info'|'light'|'dark')}
   */
  color: PropTypes.string,
  /**
   * Component size variations.
   * @type {('sm'|'md'|'lg')}
   */
  size: PropTypes.string,
  /**
   * Component position variations.
   * @type {('start'|'center'|'end')}
   */
  justify: PropTypes.string,
};

export default CSSModule(Spinner, styles, { allowMultiple: true });